<template>
  <div class="offline-export-box outer-page-primary">
    <div class="header-box">
      <div class="title-box">
        <div class="symbol" />
        <div class="title">离线数据包</div>
      </div>
    </div>
    <div class="operation-box">
      <div class="action-btns-box common-button-box btn-group-primary">
        <el-button
          class="primary-btn gr8"
          v-if="isChecked('Project.OfflinePackageManage.Export')"
          type="primary"
          size="small"
          @click="openExportDialog">
          导出
        </el-button>
        <div class="common-dropdown-box">
          <el-dropdown
            placement="bottom-start"
            @command="batchOperate">
            <el-button
              class="normal-btn"
              size="small">
              <span>批量操作</span>
              <i class="el-icon-arrow-down" />
            </el-button>
            <el-dropdown-menu
              v-if="
                isChecked('Project.OfflinePackageManage.BatchDownload') ||
                isChecked('Project.OfflinePackageManage.BatchDelete')
              "
              slot="dropdown"
              class="dropdown-menu dropdown-primary"
              :append-to-body="false">
              <el-dropdown-item
                v-if="isChecked('Project.OfflinePackageManage.BatchDownload')"
                command="1">
                批量下载
              </el-dropdown-item>
              <el-dropdown-item
                v-if="isChecked('Project.OfflinePackageManage.BatchDelete')"
                command="2">
                批量删除
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="filter-box">
        <div class="filter-item-box">
          <div class="label-box searchLabel">所属项目：</div>
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              filterable
              remote
              clearable
              :remote-method="filterProj"
              :loading="filterProjLoading"
              :popper-append-to-body="false"
              v-model="projId"
              placeholder="请输入项目名称"
              @change="handleProjChange">
              <template slot="prefix">
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search" />
              </template>
              <div>
                <el-option
                  v-if="!filterProjName"
                  value="all"
                  label="所有" />
                <el-option
                  v-for="(item, index) in projList"
                  :key="index"
                  :title="item.projectName"
                  :label="item.projectName"
                  :value="item.projectId" />
              </div>
            </el-select>
          </div>
        </div>
        <div class="filter-item-box">
          <div class="label-box searchLabel">数据类型：</div>
          <div class="common-select-box">
            <el-cascader
              v-if="showCascader"
              :append-to-body="false"
              class="primary-select"
              size="small"
              popper-class="common-cascader-box"
              :options="dataTypeOptions"
              v-model="dataType"
              clearable
              @change="handleCascaderChange"
              @visible-change="visibleChange" />
          </div>
        </div>
        <div class="filter-item-box">
          <div class="label-box searchLabel">导出状态：</div>
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              :popper-append-to-body="false"
              v-model="status"
              @change="handleStatusChange">
              <el-option
                value="all"
                label="所有" />
              <el-option
                :value="2"
                label="排队中" />
              <el-option
                :value="0"
                label="导出中" />
              <el-option
                :value="1"
                label="导出成功" />
              <el-option
                :value="-1"
                label="导出失败" />
            </el-select>
          </div>
        </div>
        <div class="filter-item-box">
          <div class="common-input-box">
            <el-input
              class="input-primary"
              size="small"
              placeholder="请输入名称搜索"
              v-model="name"
              clearable
              @clear="search"
              @keyup.enter.native="search">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="search" />
            </el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="export-data-box">
      <div v-if="loading">
        <Spin
          :pointNum="8"
          :translateX="25"
          background="var(--base-primary-bgColor)" />
      </div>
      <div
        class="common-table-box"
        v-if="!loading">
        <el-table
          highlight-selection-row
          :header-row-class-name="customHeader"
          ref="modelTable"
          height="100%"
          class="publish-table"
          row-key="id"
          :data="dataList"
          @select="selectChange"
          @select-all="selectChange">
          <el-table-column
            type="selection"
            width="60"
            :reserve-selection="true" />
          <el-table-column
            label="序号"
            type="index"
            width="55" />
          <el-table-column
            label="名称/大小"
            width="280">
            <template v-slot="{ row }">
              <div
                class="text-overflow"
                :title="row.name">
                {{ row.name }}
              </div>
              <div>
                {{
                  `${formatFileSize(row.length).fileSize}${
                    formatFileSize(row.length).unit
                  }`
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数据类型">
            <template v-slot="{ row }">
              <span>{{ getDataType(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="导出状态"
            width="150">
            <template v-slot="{ row }">
              <div
                v-if="row.status === -1"
                class="status-box">
                <div class="circle bg-color3" />
                <span class="color3">导出失败</span>
                <el-tooltip
                  :effect="$theme.tooltipKey()"
                  placement="top-start"
                  popper-class="common-panel-tooltip-box">
                  <div
                    slot="content"
                    class="content-box">
                    {{ row.failReason }}
                  </div>
                  <div class="icon-box">
                    <i class="el-icon-warning" />
                  </div>
                </el-tooltip>
                <icon-svg
                  title="重新导出"
                  class="icon"
                  icon-class="ic-zaicijiexi"
                  @click.native="reExport(row)" />
              </div>
              <div
                class="common-progress-box"
                v-if="row.status === 0">
                <el-progress
                  class="progress-primary"
                  :show-text="false"
                  :percentage="row.progress" />
                <div class="custom-text">
                  <div class="text">{{ `${row.progress}%` }}</div>
                </div>
              </div>
              <div
                v-if="row.status === 1"
                class="status-box">
                <div class="circle bg-color4" />
                <span class="color4">导出成功</span>
              </div>
              <div
                v-if="row.status === 2"
                class="status-box">
                <div class="circle bg-color2" />
                <span class="color2">排队中</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="所属项目">
            <template v-slot="{ row }">
              <span
                class="text-overflow"
                :title="row.projectName">
                {{ row.projectName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="创建人">
            <template v-slot="{ row }">
              <span
                class="text-overflow"
                :title="row.creatorName">
                {{ row.creatorName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="开始时间/结束时间"
            width="200">
            <template v-slot="{ row }">
              <div>{{ formatTime(row.creationTime) }}</div>
              <div v-if="row.status === 1">
                {{ row.finishTime ? formatTime(row.finishTime) : '--' }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column
            label="到期时间"
            width="200">
            <template v-slot="{ row }">
              <div>{{ formatTime(row.expirationTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="查看密码"
            width="240">
            <template v-slot="{ row }">
              <div
                v-if="row.password"
                class="password-box">
                <div
                  v-if="isPassWordVisible(row)"
                  class="password-visible-box">
                  {{ row.password }}
                </div>
                <div
                  v-else
                  class="password-hiddden-box">
                  **********
                </div>
                <div
                  class="icon-box"
                  @click="toggleViewPassWord(row)">
                  <icon-svg
                    v-if="isPassWordVisible(row)"
                    title="隐藏密码"
                    icon-class="icon-qiehuanyincang" />
                  <icon-svg
                    v-else
                    title="隐藏密码"
                    icon-class="icon-qiehuanxianshi-011" />
                </div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180">
            <template v-slot="{ row }">
              <div class="common-button-box operation-cell">
                <el-button
                  v-if="isChecked('Project.OfflinePackageManage.Download')"
                  type="text"
                  size="small"
                  @click="downloadById(row)"
                  :disabled="row.status !== 1">
                  下载
                </el-button>
                <el-button
                  v-if="isChecked('Project.OfflinePackageManage.SetPass')"
                  type="text"
                  size="small"
                  @click="setValidity(row)"
                  :disabled="row.status !== 1">
                  设置有效性
                </el-button>
                <el-button
                  v-if="isChecked('Project.OfflinePackageManage.Delete')"
                  type="text"
                  size="small"
                  @click="deleteById(row)"
                  :disabled="row.status === 0 || row.status === 2">
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="common-empty-box">
              <bj-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <template slot="description">
                  <div class="empty-text">抱歉，没有找到相关内容</div>
                </template>
              </bj-empty>
            </div>
          </template>
        </el-table>
        <div class="common-pagination-box">
          <el-pagination
            class="pagination-primary"
            popper-class="common-pagination-popper-box"
            layout="sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100, 150, 200]"
            :page-size="pageSize"
            :current-page="currPage"
            :total="total"
            @size-change="pageSizeChange"
            @current-change="pageChange" />
        </div>
      </div>
    </div>
    <ExportDialog
      ref="exportDialog"
      :visible="isExportDialogVisible"
      :openSetvalidityDialog="openSetvalidityDialog"
      :closeDialog="closeExportDialog" />
    <SetValidityDialog
      :visible="isSetValidtyDialogVisible"
      :mode="currMode"
      :currExportInfo="currExportInfo"
      :exportData="exportData"
      :updateValidityInfo="updateValidityInfo"
      :closeExportDialog="closeExportDialog"
      :closeDialog="closeSetvalidityDialog" />
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'
import ExportDialog from './components/ExportDialog.vue'
import SetValidityDialog from './components/SetValidityDialog.vue'

import { Store } from '@/utils/store'
import { formatTime, formatFileSize, getTokenId } from '@/utils/generalMethods'

import {
  getExportOptionalProjListService,
  getOfflineExportListService,
  offlineDataSetExportService,
  offlineSceneExportService,
  updateOfflinePackageValidityService,
  deleteOfflineExportService,
  batchDeleteOfflineExportService,
  reOfflineExportService
} from '@/service/interface'

export default {
  data() {
    return {
      customHeader: '',
      loading: false,
      projId: undefined,
      filterProjLoading: false,
      filterProjName: '',
      projList: [],
      dataType: undefined,
      status: undefined,
      name: '',
      dataList: [],
      selectDatas: [],
      // 密码是否为可见的数据，用于调整密码样式
      passWordVisibleDatas: [],
      pageSize: 10,
      currPage: 1,
      total: 0,
      dataTypeOptions: [
        {
          value: 'dataSet',
          label: '数据集',
          children: [
            { value: 'allDataSet', label: '全部' },
            { value: 'Model', label: '模型' },
            { value: 'ModelGroup', label: '模型组' },
            { value: 'Rs', label: '遥感影像' },
            { value: 'Wmts', label: 'WMTS' },
            { value: 'Osgb', label: '倾斜摄影' },
            { value: 'Panorama', label: '360全景图' },
            { value: 'PointCloud', label: '点云' },
            { value: 'Cad', label: '二维图纸' },
            { value: 'Vector', label: '矢量数据' }
          ]
        },
        { value: 1, label: '场景' }
      ],

      isExportDialogVisible: false,

      isSetValidtyDialogVisible: false,
      currMode: '', // 设置有效性弹窗当前模式
      currExportInfo: null, // 当前需要设置有效性的数据
      showCascader: true
    }
  },
  components: {
    Spin,
    ExportDialog,
    SetValidityDialog
  },
  mounted() {
    this.initProjList()
    this.initOfflineExportList()
    this.$nextTick(() => {
      setTimeout(() => {
        const currentBody = this.$refs.modelTable?.bodyWrapper
        currentBody &&
          currentBody.addEventListener('scroll', ev => {
            const scrollTop = ev.target.scrollTop
            this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
          })
      }, 500)
    })
  },
  beforeDestroy() {
    this.destroyTimer()
  },
  methods: {
    initOfflineExportList() {
      this.loading = true
      this.queryOffflineExportList().then(dataList => {
        this.dataList = dataList

        this.timer && clearInterval(this.timer)
        let exportingStatus = [0, 2]
        let exportingData = dataList.filter(el =>
          exportingStatus.includes(el.status)
        )
        if (exportingData.length) {
          this.timer = setInterval(this.refreshExportList, 5 * 1000)
        }

        this.loading = false
      })
    },
    updateOfflineExportList() {
      return new Promise(resolve => {
        this.loading = true
        this.queryOffflineExportList().then(dataList => {
          this.dataList = dataList

          this.timer && clearInterval(this.timer)
          let exportingStatus = [0, 2]
          let exportingData = dataList.filter(el =>
            exportingStatus.includes(el.status)
          )
          if (exportingData.length) {
            this.timer = setInterval(this.refreshExportList, 5 * 1000)
          }

          this.loading = false
          resolve()
        })
      })
    },
    openExportDialog() {
      this.isExportDialogVisible = true
    },
    closeExportDialog() {
      let domRef = this.$refs.exportDialog
      domRef.clearData()
      this.isExportDialogVisible = false
    },
    exportData(params) {
      return new Promise(resolve => {
        let domRef = this.$refs.exportDialog
        let exportInfo = domRef.getExportInfo()
        if (exportInfo.exportType === 'DataSet') {
          params.projId = exportInfo.projId
          params.items = exportInfo.items
          this.exportDataSet(params).then(() => {
            this.updateOfflineExportList().then(() => {
              resolve()
            })
          })
        } else {
          params.projId = exportInfo.projId
          params.sceneIds = exportInfo.sceneIds
          this.exportScene(params).then(() => {
            this.updateOfflineExportList().then(() => {
              resolve()
            })
          })
        }
      })
    },
    exportDataSet(params) {
      return new Promise(resolve => {
        offlineDataSetExportService(params).then(response => {
          if (response.isSuccess) {
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    exportScene(params) {
      return new Promise(resolve => {
        offlineSceneExportService(params).then(response => {
          if (response.isSuccess) {
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    openSetvalidityDialog(exportMOde) {
      this.currMode = exportMOde
      this.isSetValidtyDialogVisible = true
    },
    closeSetvalidityDialog() {
      this.currMode = ''
      this.currExportInfo = null
      this.isSetValidtyDialogVisible = false
    },
    undateOfflineExportList() {
      this.queryOffflineExportList().then(() => {
        this.dataList = []
      })
    },
    refreshExportList() {
      this.queryOffflineExportList().then(dataList => {
        this.dataList = dataList

        let exportingStatus = [0, 2]
        let exportingData = dataList.filter(el =>
          exportingStatus.includes(el.status)
        )
        if (exportingData.length) {
          this.timer && clearInterval(this.timer)
          this.timer = null
          this.timer = setInterval(this.refreshExportList, 5 * 1000)
        } else {
          this.timer && clearInterval(this.timer)
          this.timer = null
        }
      })
    },
    initProjList() {
      getExportOptionalProjListService({}).then(response => {
        if (response.isSuccess) {
          let projList = response.data
          this.projList = projList
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    filterProj(filterName) {
      this.filterProjName = filterName
      this.filterProjLoading = true
      getExportOptionalProjListService({ projectName: filterName }).then(
        response => {
          if (response.isSuccess) {
            let projList = response.data
            this.projList = projList
            this.filterProjLoading = false
          } else {
            this.$message.error(response.errMsg)
          }
        }
      )
    },
    handleProjChange(value) {
      this.currPage = 1
      this.filterProjName = ''
      if (!value) {
        this.projId = 'all'
      }
      this.initOfflineExportList()
    },
    handleCascaderChange(dataType) {
      if (dataType.length === 0) {
        this.exportType = undefined
      }
      if (dataType.length === 1) {
        let value = dataType[0]
        this.exportType = value
      }
      if (dataType.length === 2) {
        let value = dataType[1]
        this.exportType = value
      }
      this.currPage = 1
      this.initOfflineExportList()
    },
    visibleChange(flag) {
      if (flag) return
      this.showCascader = false
      this.$nextTick(() => {
        this.showCascader = true
      })
    },
    handleStatusChange() {
      this.currPage = 1
      this.initOfflineExportList()
    },
    search() {
      this.currPage = 1
      this.initOfflineExportList()
    },
    pageSizeChange(pageSize) {
      this.currPage = 1
      this.pageSize = pageSize
      this.initOfflineExportList()
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.initOfflineExportList()
    },
    selectChange(selection) {
      this.selectDatas = selection
    },
    reExport(exportInfo) {
      let id = exportInfo.id
      reOfflineExportService(id).then(response => {
        if (response.isSuccess) {
          this.$message.success('开始重新导出')
          this.refreshExportList()
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    batchOperate(command) {
      switch (command) {
        case '1':
          this.batchDownlod()
          break
        case '2':
          this.batchDelete()
          break
      }
    },
    batchDownlod() {
      if (!this.selectDatas.length) {
        this.$message.warning('请先勾选文件')
        return
      }

      let validDatas = this.selectDatas.filter(el => el.status === 1)
      if (!validDatas.length) {
        this.$message.warning('无可下载数据，请检查所选数据的导出状态')
        return
      }

      let inValidDatas = this.selectDatas.filter(el => el.status !== 1)
      if (inValidDatas.length) {
        let message = '所选数据中包含未导出成功的数据，是否跳过，继续下载?'
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.downloadFiles(validDatas)
          })
          .catch(() => {
            this.$message.info('取消下载')
          })
        return
      }

      this.downloadFiles(validDatas)
    },
    batchDelete() {
      if (!this.selectDatas.length) {
        this.$message.warning('请先勾选文件')
        return
      }

      // prettier-ignore
      let validDatas = this.selectDatas.filter((el) => el.status === -1 || el.status === 1);
      if (!validDatas.length) {
        this.$message.warning('所选数据不支持删除')
        return
      }
      // prettier-ignore
      let inValidDatas = this.selectDatas.filter((el) => el.status === 0 || el.status === 2);
      if (inValidDatas.length) {
        // prettier-ignore
        let message = "所选数据中包含排队中或正在导出的数据，是否跳过，删除其余数据?";
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let ids = validDatas.map(el => el.id)
            batchDeleteOfflineExportService({ ids }).then(response => {
              if (response.isSuccess) {
                this.$message.success('删除成功')
                this.currPage = 1
                this.initOfflineExportList()
              } else {
                this.$message.error(response.errMsg)
              }
            })
          })
          .catch(() => {
            // this.$message.info('取消删除')
          })
        return
      }

      let ids = validDatas.map(el => el.id)
      let msg = '该操作将会删除资源包文件，并清除该条记录，确认要删除吗?'
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          batchDeleteOfflineExportService({ ids }).then(response => {
            if (response.isSuccess) {
              this.$message.success('删除成功')
              this.currPage = 1
              this.initOfflineExportList()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    downloadById(exportInfo) {
      this.downloadFiles([exportInfo])
    },
    setValidity(exportInfo) {
      this.currMode = 'setValidity'
      this.currExportInfo = exportInfo
      this.isSetValidtyDialogVisible = true
    },
    updateValidityInfo(params) {
      let offlinePackageId = this.currExportInfo.id
      params.offlinePackageId = offlinePackageId
      return new Promise(resolve => {
        updateOfflinePackageValidityService(params).then(response => {
          if (response.isSuccess) {
            this.updateOfflineExportList().then(() => {
              this.$message.success('设置成功')
              resolve()
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    deleteById(exportInfo) {
      // prettier-ignore
      let warningMsg = "该操作将会删除资源包文件，并清除该条记录，确认要删除吗?";
      this.$confirm(warningMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let id = exportInfo.id
          deleteOfflineExportService(id).then(response => {
            if (response.isSuccess) {
              this.$message.success('删除成功')
              this.currPage = 1
              this.initOfflineExportList()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    toggleViewPassWord(dataInfo) {
      let findIndex = this.passWordVisibleDatas.findIndex(
        el => el.id === dataInfo.id
      )
      if (findIndex === -1) {
        this.passWordVisibleDatas.push(dataInfo)
      } else {
        this.passWordVisibleDatas.splice(findIndex, 1)
      }
    },
    isPassWordVisible(dataInfo) {
      let visible = false
      let find = this.passWordVisibleDatas.find(el => el.id === dataInfo.id)
      if (find) {
        visible = true
      }
      return visible
    },
    getDataType(exportInfo) {
      let dataTypeDes = ''
      let exportType = exportInfo.exportType
      let scheme = exportInfo.scheme
      let formatType = exportInfo.formatType
      switch (exportType) {
        case 1:
          dataTypeDes = '场景'
          break
        case 2:
          if (scheme === 'Bim') {
            if (formatType === 1) {
              dataTypeDes = '模型'
            } else {
              dataTypeDes = '模型组'
            }
          } else if (scheme === 'Rs') {
            dataTypeDes = '遥感影像'
          } else if (scheme === 'Wmts') {
            dataTypeDes = 'WMTS'
          } else if (scheme === 'Osgb') {
            dataTypeDes = '倾斜摄影'
          } else if (scheme === 'Panorama') {
            dataTypeDes = '360全景图'
          } else if (scheme === 'PointCloud') {
            dataTypeDes = '点云'
          } else if (scheme === 'Cad') {
            dataTypeDes = '二维图纸'
          } else if (scheme === 'Vector') {
            dataTypeDes = '矢量数据'
          }
          break
      }
      return dataTypeDes
    },
    queryOffflineExportList() {
      return new Promise(resolve => {
        let params = this.getQueryParams()
        getOfflineExportListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataList = data.items
            dataList.forEach(el => {
              el.password = el.password ? atob(el.password) : ''
              el.progress = Number((el.progress * 100).toFixed(2))
            })
            this.total = data.totalCount
            resolve(dataList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getQueryParams() {
      let params = {
        projId: this.projId === 'all' ? undefined : this.projId,
        status: this.status === 'all' ? undefined : this.status,
        name: this.name,
        resultCount: this.pageSize,
        skipCount: (this.currPage - 1) * this.pageSize
      }

      switch (this.exportType) {
        case 'all':
          params.exportType = undefined
          break
        case 0:
        case 1:
          params.exportType = this.exportType
          break
        case 'allDataSet':
          params.exportType = 2
          break
        case 'Model':
          params.exportType = 2
          params.scheme = 'Bim'
          params.formatType = 1
          break
        case 'ModelGroup':
          params.exportType = 2
          params.scheme = 'Bim'
          params.formatType = 2
          break
        case 'Rs':
        case 'Wmts':
        case 'Osgb':
        case 'Panorama':
        case 'PointCloud':
        case 'Cad':
        case 'Vector':
          params.exportType = 2
          params.scheme = this.exportType
          // params.formatType = 1;
          break
      }

      return params
    },
    downloadFiles(fileData) {
      this.$message({
        message: '开始下载文件，请勿重复操作......',
        type: 'info',
        duration: 3 * 1000
      })

      fileData.forEach((item, index) => {
        let url = ''
        let tokenId = getTokenId()
        if (window.downloadUrl.includes('http')) {
          url = `${window.downloadUrl}/${item.fileDataId}?token=${tokenId}`
        } else {
          url = `${window.serverUrl}/${window.downloadUrl}/${item.fileDataId}?token=${tokenId}`
        }

        this.downloadURL(url, index + 1)
      })
    },
    downloadURL(url, id) {
      let hiddenIFrameID = 'hiddenDownloader' + id
      let iframe = document.createElement('iframe')
      iframe.id = hiddenIFrameID
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      iframe.src = url
    },
    getExceptionMessage(files, messageTail) {
      let message = ''
      // 超过两个文件只展示前两个
      if (files.length > 2) {
        let fileNames = `${files[0]}、${files[1]}等${files.length}个文件`
        message = `${fileNames}${messageTail}`
      } else {
        message = `${files}${messageTail}`
      }
      return message
    },
    destroyTimer() {
      this.timer && clearInterval(this.timer)
      this.timer = null
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime,
    formatFileSize
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.offline-export-box {
  height: 100%;

  .header-box {
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    text-align: left;

    .title-box {
      display: flex;
      align-items: center;

      .symbol {
        width: 4px;
        height: 20px;
        // background: var(--primary-color);
      }

      .title {
        margin-left: 10px;
        color: var(--offlineData-page-title);
      }
    }
  }

  .operation-box {
    display: flex;
    justify-content: space-between;
    // margin-top: 10px;

    .common-button-box {
      display: flex;

      // .el-button {
      //   width: 90px;
      //   display: flex;
      //   justify-content: center;
      // }

      // .el-button + .el-button {
      //   margin-left: 0px;
      // }

      // .common-dropdown-box {
      //   .dropdown-menu {
      //     width: 90px;
      //   }
      // }
    }

    .filter-box {
      display: flex;

      .filter-item-box {
        display: flex;

        .common-select-box {
          width: 180px;
          text-align: left;
        }
      }
    }
  }

  .export-data-box {
    height: calc(100% - 109px);
    padding: 0 16px;

    .common-table-box {
      height: calc(100% - 64px);

      .common-button-box {
        display: flex;
        justify-content: flex-start;
      }

      .status-box {
        display: flex;
        font-size: 12px;
        align-items: center;

        .circle {
          width: 5px;
          height: 5px;
          margin: auto 5px auto 0px;
          border-radius: 50%;
        }

        .icon-box {
          margin: 0px 5px;
          color: var(--error-status-color);
        }

        .icon {
          cursor: pointer;
          margin-top: 2px;
        }

        .bg-color1 {
          background: var(--table-cell-status-text-color);
        }

        .bg-color2 {
          background: var(--runing-status-color);
        }

        .bg-color3 {
          background: var(--error-status-color);
        }

        .bg-color4 {
          background: var(--success-status-color);
        }

        .color1 {
          color: var(--table-cell-status-text-color);
        }

        .color2 {
          color: var(--runing-status-color);
        }

        .color3 {
          color: var(--error-status-color);
        }

        .color4 {
          color: var(--success-status-color);
        }
      }

      .common-progress-box {
        display: flex;

        .el-progress {
          width: 40%;
        }

        .custom-text {
          width: 60px;
          line-height: 12px;
          font-size: 12px;
          text-align: center;

          .text {
            color: #73fbfd;
          }
        }

        &:hover {
          .custom-text {
            display: block;
          }
        }
      }

      .password-box {
        display: flex;
        align-items: center;
        color: var(--base-primary-bgColor);

        .password-visible-box {
          width: 80px;
          user-select: all;
          color: var(--default-color);
        }

        .password-hiddden-box {
          display: inline-block;
          width: 80px;
          vertical-align: middle;
        }

        .icon-box {
          margin: auto 10px;
          cursor: pointer;
        }
      }

      .common-pagination-box {
        text-align: center;
      }
    }
  }
}
</style>
